import { PackagingLevel } from "../../shared/packaging";
import { useFarmGatePackagingMutations } from "../../shared/packaging/hooks/useFarmGatePackagingMutations";
import { PackagingLevelProps } from "../../shared/packaging/packagingLevel.types";

type FarmGatePackagingProps = Omit<PackagingLevelProps, "gate" | "gateId" | "mutations"> & {
  farmGateId: string;
};

const Packaging = ({ farmGateId, ...props }: FarmGatePackagingProps) => {
  const mutations = useFarmGatePackagingMutations();

  return <PackagingLevel gate="farm-gate" gateId={farmGateId} mutations={mutations} {...props} />;
};

export default Packaging;
